export default __webpack_public_path__ + "static/Hochzeit Preisliste_Final_new-5bde16fed8046a102404092e1217476a.jpg";